import React from 'react'
import { useRouter } from 'next/router'

import {
  NonProviderSlugs,
  Providers,
  Page,
  Location,
  Facets,
  Keyword,
  RemoveDuplicateProviders,
} from 'utils/DirectoryParser'
import DirectoriesContainer from 'components/Directories/DirectoriesContainer'
import useAnalyticsPageTracker from 'hooks/useAnalyticsPageTracker'

const Directories = (props) => {
  const directoryProviders = (directoryProvider, facetSlugs) => {
    const providers = Providers(facetSlugs)
    const hasProviders = providers && providers.length > 0
    if (hasProviders && directoryProvider) {
      providers.push(directoryProvider)
      return providers
    } else if (directoryProvider) {
      return [directoryProvider]
    } else if (hasProviders) {
      return providers
    }
    return []
  }

  const {
    props: {
      pageProps: { directoriesCanonicalUrl },
      viewer,
      loggedIn,
    },
    directoryLabel,
    directoryProvider,
    directoryBasePath,
    directoryResultsType,
  } = props

  const router = useRouter()
  const page = Page(router)
  const location = Location(router)
  const facetSlugs = Facets(router)
  const keyword = Keyword(router)

  const directoryLinkInformation = {
    page,
    location,
    directoryResultsType,
    keyword,
    directoryPath: directoryBasePath,
    directoryProviders: RemoveDuplicateProviders(directoryProviders(directoryProvider, facetSlugs)),
    facetSlugs: NonProviderSlugs(facetSlugs),
  }

  useAnalyticsPageTracker(`directory`, router.asPath)

  return (
    <DirectoriesContainer
      directoriesCanonicalUrl={directoriesCanonicalUrl}
      directoryLabel={directoryLabel}
      directoryResultsType={directoryResultsType}
      directoryProvider={directoryProvider}
      page={page}
      location={location}
      facets={facetSlugs}
      keyword={keyword}
      directoryLinkInformation={directoryLinkInformation}
      viewer={viewer}
      loggedIn={loggedIn}
    />
  )
}

export default Directories
